import { useContext } from "react";
import styled from "styled-components";
import LayoutContext from "../../../contexts/LayoutContext";
const StyledPage = styled.div`
    &.share-location-overlay,
    &.share-location-overlay * {
        box-sizing: border-box;
    }
    &.share-location-overlay {
        background: rgba(18, 18, 18, 0.8);
        border-radius: 10px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: absolute;
        box-shadow: 4px 4px 87.4px 0px rgba(0, 0, 0, 1);
        backdrop-filter: blur(15px);
        z-index: 9;
        height: 174px;
        width: auto;
        left: 15.5px;
        right: 15.5px;
        top: 10px;
        animation: fadeIn 0.5s ease-in-out;
    }

    &.share-location-overlay::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: inherit;
        backdrop-filter: blur(15px);
        z-index: -1;
        border-radius: inherit;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .frame-295922360 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922362 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922363 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .did-you-move {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
        align-self: stretch;
    }
    .we-detected-a-new-location-do-you-want-to-share-and-use-your-new-current-location {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        height: 48px;
    }
    .frame-313709 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-xs-secondary {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-xs-primary {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    @media (max-width: 768px) {
        &.share-location-overlay {
            position: fixed;
            z-index: 9999999;
            top: 18px;
            background: rgb(18 18 18 / 33%);
            backdrop-filter: none;
        }
    }
`;
export default function NewLocationDetected({ onDismiss, locationBtnClick }) {
    const { setNewLocationDetected } = useContext(LayoutContext);

    const handleClose = () => {
        setNewLocationDetected(false);
        onDismiss();
    };

    return (
        <StyledPage className="share-location-overlay">
            <div className="frame-295922360">
                <div className="frame-295922362">
                    <div className="frame-295922363">
                        <div className="did-you-move">Did you move?</div>
                        <div className="we-detected-a-new-location-do-you-want-to-share-and-use-your-new-current-location">
                            We detected a new location. Do you want to share and use your new current location?
                        </div>
                    </div>
                    <div className="frame-313709">
                        <div className="btn-xs-secondary" onClick={handleClose}>
                            <div className="button">No, keep location</div>
                        </div>
                        <div className="btn-xs-primary" onClick={locationBtnClick}>
                            <div className="button">Yes</div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledPage>
    );
}
